import {
    APIDisplayNames,
    APIMajorVersions,
    APIV1MinorVersions,
    APIV2MinorVersions,
    ChangeTypes,
    ReleaseDates
} from "./variables";

export const releaseNotes = {
    "2026-09-26": {
        releaseDate: ReleaseDates["2026-09-26"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-09-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>Issue Condition</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IssueCondition]
            },
            {
                "message": `<p class="label">Added Instrument Criteria</p>
                <ul>
                    <li><code>optionRightType</code></li>
                    <li><code>equityType</code></li>
                    <li><code>securityType</code></li>
                    <li><code>contractType</code></li>
                </ul>
                <p class="label">Added Listing Criteria</p>
                <ul>
                    <li><code>segmentMic</code></li>
                    <li><code>operatingMic</code></li>
                    <li><code>optionRightType</code></li>
                    <li><code>equityType</code></li>
                    <li><code>securityType</code></li>
                    <li><code>listingStatus</code></li>
                    <li><code>tradingStatus</code></li>
                    <li><code>contractType</code></li>
                </ul>
                <p class="label">Added fields</p>
                <ul>
                    <li><code>optionRightType</code></li>
                    <li><code>sedol</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.CriteriaSearch]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>sedol</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.ListingBase, APIDisplayNames.InstrumentMarkets]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>optionRightType</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentBase, APIDisplayNames.FreeTextSearch]
            },
            {
                "message": `<p class="label">Deprecated field</p>
                <ul>
                    <li><code>optionType</code></li>
                </ul>`,
                "type": ChangeTypes.Deprecated,
                "apis": [APIDisplayNames.CriteriaSearch, APIDisplayNames.InstrumentBase, APIDisplayNames.FreeTextSearch]
            },
            {
                "message": `<p class="label">Added API</p>
                <p>Streaming Market Data V3 (Beta)</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.StreamingMarketDataV3]
            }
        ]
    },
    "2026-07-25": {
        releaseDate: ReleaseDates["2026-07-25"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-07-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>MiFID II Cost & Charges</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.MifidIICostAndCharges]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>consolidatedOpen</code></li>
                    <li><code>consolidatedClose</code></li>
                    <li><code>consolidatedHigh</code></li>
                    <li><code>consolidatedLow</code></li>
                    <li><code>consolidatedVolume</code></li>
                    <li><code>accruedInterestTPlus3</code></li>
                    <li><code>referencePrice</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot,
                    APIDisplayNames.EndOfDaySnapshot,
                    APIDisplayNames.EndOfDayHistory
                ]
            },
            {
                "message": `<p class="label">Added subfields</p>
                <ul>
                    <li><code>effectiveDate</code></li>
                    <li><code>originalMarketBc</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot,
                    APIDisplayNames.EndOfDaySnapshot
                ]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>announcementDate</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.InstrumentDetail
                ]
            }
        ]
    },
    "2026-07-04": {
        releaseDate: ReleaseDates["2026-07-04"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-06-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>MiFID II suitability for instruments</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.MifidIISuitability]
            },
            {
                "message": `<p class="label">Can newly be requested via Instrument IDs</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.Estimates, APIDisplayNames.Fundamentals]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>floatingShares</code></li>
                    <li><code>percentageFloatingShares</code></li>
                    <li><code>nonFloatingShares</code></li>
                    <li><code>totalSharesHeld</code></li>
                    <li><code>shareholderType</code></li>
                    <li><code>sharesHeld</code></li>
                    <li><code>percentageSharesHeld</code></li>
                    <li><code>marketValue</code></li>
                    <li><code>currentRank</code></li>
                    <li><code>name</code></li>
                    <li><code>currentSharesHeld</code></li>
                    <li><code>currentPercentageSharesHeld</code></li>
                    <li><code>currentMarketValue</code></li>
                    <li><code>previousQuarterPercentageSharesHeld</code></li>
                    <li><code>prePreviousQuarterPercentageSharesHeld</code></li>
                    <li><code>totalEmployees</code></li>
                    <li><code>returnOnAssets</code></li>
                    <li><code>returnOnCapital</code></li>
                    <li><code>returnOnEquity</code></li>
                    <li><code>grossMargin</code></li>
                    <li><code>ebitdaMargin</code></li>
                    <li><code>ebitMargin</code></li>
                    <li><code>incomeFromContinuingOperationsMargin</code></li>
                    <li><code>netIncomeMargin</code></li>
                    <li><code>currentRatio</code></li>
                    <li><code>quickRatio</code></li>
                    <li><code>averageDaysInventoryOutstanding</code></li>
                    <li><code>averageDaysSalesOutstanding</code></li>
                    <li><code>averageDaysPayableOutstanding</code></li>
                    <li><code>averageCashConversionCycle</code></li>
                    <li><code>totalAssetTurnover</code></li>
                    <li><code>fixedAssetTurnover</code></li>
                    <li><code>accountsReceivableTurnover</code></li>
                    <li><code>inventoryTurnover</code></li>
                    <li><code>totalDebtToEquity</code></li>
                    <li><code>totalDebtToCapital</code></li>
                    <li><code>longTermDebtToEquity</code></li>
                    <li><code>longTermDebtToCapital</code></li>
                    <li><code>totalLiabilitiesToTotalAssets</code></li>
                    <li><code>ebitToInterestExpenses</code></li>
                    <li><code>ebitdaToInterestExpenses</code></li>
                    <li><code>ebitdaMinusCapexToInterestExpenses</code></li>
                    <li><code>totalDebtToEbitda</code></li>
                    <li><code>netDebtToEbitda</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.Fundamentals
                ]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>sharesOutstanding</code></li>
                    <li><code>instrumentShortName</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.IndexComposition
                ]
            }
        ]
    },
    "2026-05-23": {
        releaseDate: ReleaseDates["2026-05-23"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-05-16"],
        changeList: [
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>lastBid</code></li>
                    <li><code>lastAsk</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot,
                    APIDisplayNames.EndOfDaySnapshot,
                    APIDisplayNames.EndOfDayHistory
                ]
            }
        ]
    },
    "2026-05-02": {
        releaseDate: ReleaseDates["2026-05-02"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-05-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>Holiday schedule for markets</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.MarketHolidays]
            },
            {
                "message": `<p class="label">Added Instrument Criteria</p>
                <ul>
                    <li><code>couponType</code></li>
                    <li><code>currentCouponRate.from</code></li>
                    <li><code>currentCouponRate.to</code></li>
                </ul>
                <p class="label">Added Listing Criteria</p>
                <ul>
                    <li><code>listingCategory</code></li>
                    <li><code>couponType</code></li>
                    <li><code>currentCouponRate.from</code></li>
                    <li><code>currentCouponRate.to</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.CriteriaSearch]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>tradingDays</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.MarketBase
                ]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>nextCallDate</code></li>
                    <li><code>nextPutDate</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.InstrumentDetail
                ]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>premium</code></li>
                    <li><code>premiumPerAnnum</code></li>
                    <li><code>accruedInterestTPlusN</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot,
                    APIDisplayNames.EndOfDaySnapshot,
                    APIDisplayNames.EndOfDayHistory
                ]
            }
        ]
    },
    "2026-03-28": {
        releaseDate: ReleaseDates["2026-03-28"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-03-01"],
        changeList: [
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>lookup.bc</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.InstrumentBase,
                    APIDisplayNames.EntityBase,
                    APIDisplayNames.ListingBase,
                    APIDisplayNames.MarketBase,
                    APIDisplayNames.InstrumentSymbology,
                    APIDisplayNames.ListingSymbology,
                    APIDisplayNames.InstrumentMarkets,
                    APIDisplayNames.IndexComposition,
                    APIDisplayNames.InstrumentClassification,
                    APIDisplayNames.EntityClassification,
                    APIDisplayNames.InstrumentDetail,
                    APIDisplayNames.IntradayHistory,
                    APIDisplayNames.StreamingIntradayTradesWithHistory,
                    APIDisplayNames.Estimates,
                    APIDisplayNames.Fundamentals
                ]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>lookup.bc</code></li>
                    <li><code>volumeOffMarket</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.EndOfDayHistory
                ]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>lookup.bc</code></li>
                    <li><code>volumeOffMarket</code></li>
                    <li><code>timeValue</code></li>
                    <li><code>averageDailyVolumeTotalMonthToDate</code></li>
                    <li><code>averageDailyVolumePreviousMonthToDate</code></li>
                    <li><code>averageDailyVolumeTotalPreviousMonthToDate</code></li>
                    <li><code>dailyAdjustmentFactor</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.EndOfDaySnapshot
                ]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>lookup.bc</code></li>
                    <li><code>volumeOffMarket</code></li>
                    <li><code>timeValue</code></li>
                    <li><code>averageDailyVolumeTotalMonthToDate</code></li>
                    <li><code>averageDailyVolumePreviousMonthToDate</code></li>
                    <li><code>averageDailyVolumeTotalPreviousMonthToDate</code></li>
                    <li><code>dailyAdjustmentFactor</code></li>
                    <li><code>close1Week</code></li>
                    <li><code>close4Week</code></li>
                    <li><code>close12Week</code></li>
                    <li><code>close26Week</code></li>
                    <li><code>close52Week</code></li>
                    <li><code>valuationPrice1Week</code></li>
                    <li><code>valuationPrice4Week</code></li>
                    <li><code>valuationPrice12Week</code></li>
                    <li><code>valuationPrice26Week</code></li>
                    <li><code>valuationPrice52Week</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot
                ]
            },
            {
                "message": `<p class="label">Added Instrument Criteria</p>
                <ul>
                    <li><code>issueDate.from</code></li>
                    <li><code>issueDate.to</code></li>
                    <li><code>expirationDate.from</code></li>
                    <li><code>expirationDate.to</code></li>
                    <li><code>optionStrikePrice.from</code></li>
                    <li><code>optionStrikePrice.to</code></li>
                    <li><code>optionStrikePriceCurrency</code></li>
                    <li><code>contractSymbol</code></li>
                    <li><code>contractSize</code></li>
                    <li><code>exerciseType</code></li>
                    <li><code>rightType</code></li>
                    <li><code>underlyingInstrumentType</code></li>
                    <li><code>underlyingNominalCurrency</code></li>
                    <li><code>maturityDate.from</code></li>
                    <li><code>maturityDate.to</code></li>
                    <li><code>etdContractSpecificationType</code></li>
                    <li><code>settlementType</code></li>
                    <li><code>contractDateYear.from</code></li>
                    <li><code>contractDateYear.to</code></li>
                    <li><code>contractDateMonth.from</code></li>
                    <li><code>contractDateMonth.to</code></li>
                    <li><code>contractDateDay.from</code></li>
                    <li><code>contractDateDay.to</code></li>
                    <li><code>contractFrequency</code></li>
                    <li><code>sixVersionNumber</code></li>
                    <li><code>contractSymbol</code></li>
                    <li><code>ticker</code></li>
                </ul>
                <p class="label">Added Listing Criteria</p>
                <ul>
                    <li><code>issuer.ids</code></li>
                    <li><code>issuer.scheme</code></li>
                    <li><code>sixSector</code></li>
                    <li><code>issuerCountry</code></li>
                    <li><code>instrumentStatus</code></li>
                    <li><code>issueDate.from</code></li>
                    <li><code>issueDate.to</code></li>
                    <li><code>openingDate.from</code></li>
                    <li><code>openingDate.to</code></li>
                    <li><code>underlying.ids</code></li>
                    <li><code>underlying.scheme</code></li>
                    <li><code>underlyingInstrumentType</code></li>
                    <li><code>underlyingNominalCurrency</code></li>
                    <li><code>nominalCurrency</code></li>
                    <li><code>etdContractSpecificationType</code></li>
                    <li><code>settlementType</code></li>
                    <li><code>contractDateYear.from</code></li>
                    <li><code>contractDateYear.to</code></li>
                    <li><code>contractDateMonth.from</code></li>
                    <li><code>contractDateMonth.to</code></li>
                    <li><code>contractDateDay.from</code></li>
                    <li><code>contractDateDay.to</code></li>
                    <li><code>contractFrequency</code></li>
                    <li><code>sixVersionNumber</code></li>
                    <li><code>contractSymbol</code></li>
                    <li><code>rootSymbol</code></li>
                    <li><code>ticker</code></li>
                    <li><code>expirationDate.from</code></li>
                    <li><code>expirationDate.to</code></li>
                    <li><code>optionStrikePrice.from</code></li>
                    <li><code>optionStrikePrice.to</code></li>
                    <li><code>optionStrikePriceCurrency</code></li>
                    <li><code>contractSymbol</code></li>
                    <li><code>contractSize</code></li>
                    <li><code>exerciseType</code></li>
                    <li><code>rightType</code></li>
                    <li><code>maturityDate.from</code></li>
                    <li><code>maturityDate.to</code></li>
                    <li><code>sedol</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.CriteriaSearch]
            },
            {
                "message": `<p class="label">Added Listing request schemes</p>
                <ul>
                    <li><code>VALOR_MIC</code></li>
                    <li><code>ISIN_MIC</code></li>
                    <li><code>CUSIP_MIC</code></li>
                    <li><code>SEDOL_MIC</code></li>
                    <li><code>TICKER_MIC</code></li>
                    <li><code>WKN_MIC</code></li>
                    <li><code>FIGI_MIC</code></li>
                    <li><code>BBGTICKER_MIC</code></li>
                    <li><code>VALOR_MIC_CCY</code></li>
                    <li><code>ISIN_MIC_CCY</code></li>
                    <li><code>CUSIP_MIC_CCY</code></li>
                    <li><code>SEDOL_MIC_CCY</code></li>
                    <li><code>TICKER_MIC_CCY</code></li>
                    <li><code>WKN_MIC_CCY</code></li>
                    <li><code>FIGI_MIC_CCY</code></li>
                    <li><code>BBGTICKER_MIC_CCY</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [],
                "title": "All APIs"
            }
        ]
    },
    "2026-02-14": {
        releaseDate: ReleaseDates["2026-02-14"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2026-01-01"],
        changeList: [
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>mostLiquidMarket.ticker</code></li>
                    <li><code>primaryMarket.shortName</code></li>
                    <li><code>primaryMarket.longName</code></li>
                    <li><code>primaryMarket.bc</code></li>
                    <li><code>primaryMarket.mic</code></li>
                    <li><code>primaryMarket.country</code></li>
                    <li><code>primaryMarket.ticker</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentBase]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>tradingEvent.category</code></li>
                    <li><code>tradingEvent.timestamp</code></li>
                    <li><code>tradingEvent.unixTimestamp</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.StreamingMarketData]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>tradingEvent.category</code></li>
                    <li><code>tradingEvent.timestamp</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Added Listing request schemes</p>
                <ul>
                    <li><code>BBGTICKER_BC</code></li>
                    <li><code>FIGI_BC</code></li>
                </ul>
                <p class="label">Added Instrument request schemes</p>
                <ul>
                    <li><code>BBGTICKER</code></li>
                    <li><code>FIGI</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [],
                "title": "All APIs"
            },
            {
                "message": `<p class="label">Added 'marketCriteria'</p>
                <ul>
                    <li><code>PRIMARY_MARKET</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentMarkets]
            }
        ]
    },
    "2025-12-06": {
        releaseDate: ReleaseDates["2025-12-06"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2025-11-01"],
        changeList: [
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>currentYield</code></li>
                    <li><code>basisPointValue</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.StreamingMarketData, APIDisplayNames.IntradaySnapshot, APIDisplayNames.EndOfDaySnapshot]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>currentYield</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDayHistory]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>bbgTicker</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentSymbology]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>marketTransitionStartTime</code></li>
                    <li><code>marketTransitionEndTime</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.MarketBase]
            },
            {
                "message": `<p class="label">Added API</p>
                <p>Detailed reference data for instruments</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentDetail]
            }
        ]
    },
    "2025-10-20": {
        releaseDate: ReleaseDates["2025-10-20"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2025-10-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>Criteria search for instruments and listings</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.CriteriaSearch]
            },
            {
                "message": `<p class="label">Added input parameter</p>
                <ul>
                    <li><code>numberOfTrades</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IntradayHistory]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>volumeWeightedRate10thPercentile</code></li>
                    <li><code>volumeWeightedRate25thPercentile</code></li>
                    <li><code>volumeWeightedRate75thPercentile</code></li>
                    <li><code>volumeWeightedRate90thPercentile</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.StreamingMarketData, APIDisplayNames.EndOfDaySnapshot, APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>bbgTicker</code></li>
                    <li><code>occOptionSymbol</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.ListingSymbology]
            },
            {
                "message": `<p class="label">Added enumeration</p>
                <ul>
                    <li><code>MOST_LIQUID_MARKET</code> for field <code>marketCriteria</code></li>
                </ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentMarkets]
            }
        ]
    },
    "2025-09-02": {
        releaseDate: ReleaseDates["2025-09-02"],
        majorVersion: APIMajorVersions.v2,
        minorVersion: APIV2MinorVersions["2025-06-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>Swiss stamp duty for instruments</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.SwissStampDuty]
            },
            {
                "message": `<p class="label">All output fields are nullable except:</p>
                <ul>
                    <li><code>requestedId</code></li>
                    <li><code>requestedScheme</code></li>
                    <li><code>streamId</code></li>
                    <li><code>type</code> (streaming message)</li>
                </ul>`,
                "type": ChangeTypes.Changed,
                "apis": [
                    APIDisplayNames.InstrumentBase,
                    APIDisplayNames.EntityBase,
                    APIDisplayNames.ListingBase,
                    APIDisplayNames.MarketBase,
                    APIDisplayNames.InstrumentSymbology,
                    APIDisplayNames.ListingSymbology,
                    APIDisplayNames.InstrumentMarkets,
                    APIDisplayNames.IndexComposition,
                    APIDisplayNames.InstrumentClassification,
                    APIDisplayNames.EntityClassification,
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot,
                    APIDisplayNames.IntradayHistory,
                    APIDisplayNames.StreamingIntradayTradesWithHistory,
                    APIDisplayNames.EndOfDayHistory,
                    APIDisplayNames.EndOfDaySnapshot,
                    APIDisplayNames.FreeTextSearch,
                    APIDisplayNames.Estimates,
                    APIDisplayNames.Fundamentals
                ]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>dailyAdjustmentFactor</code></li>
                    <li><code>dividendAdjustmentFactor</code></li>
                    <li><code>aumShareClass</code></li>
                    <li><code>totalAum</code></li>
                    <li><code>volumeDerived</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDayHistory]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>aumShareClass</code></li>
                    <li><code>totalAum</code></li>
                    <li><code>volumeDerived</code></li>
                    <li><code>averagePriceMonthToDate</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDaySnapshot]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>aumShareClass</code></li>
                    <li><code>totalAum</code></li>
                    <li><code>volumeDerived</code></li>
                    <li><code>averagePriceMonthToDate</code></li>
                    <li><code>averagePrice1Week</code></li>
                    <li><code>averagePrice4Week</code></li>
                    <li><code>averagePrice12Week</code></li>
                    <li><code>averagePrice52Week</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.StreamingMarketData, APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>marketOpenTime</code></li>
                    <li><code>marketCloseTime</code></li>
                    <li><code>marketTimeZone</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.MarketBase]
            },
            {
                "message": `<p class="label">1 listing ID per request</p>`,
                "type": ChangeTypes.Changed,
                "apis": [APIDisplayNames.EndOfDayHistory, APIDisplayNames.IntradayHistory]
            },
            {
                "message": `<p class="label"><strong>All deprecated fields in V1 are removed in V2</strong></p>
                <p class="label">Summary of all the Major Version v2 changes can be found in our <a href="/portal/bfi/documentation#v2-summary">Documentation</a></p>`,
                "type": ChangeTypes.Removed,
                "apis": [
                    APIDisplayNames.InstrumentBase,
                    APIDisplayNames.EntityBase,
                    APIDisplayNames.ListingBase,
                    APIDisplayNames.MarketBase,
                    APIDisplayNames.InstrumentSymbology,
                    APIDisplayNames.ListingSymbology,
                    APIDisplayNames.InstrumentMarkets,
                    APIDisplayNames.IndexComposition,
                    APIDisplayNames.InstrumentClassification,
                    APIDisplayNames.EntityClassification,
                    APIDisplayNames.StreamingMarketData,
                    APIDisplayNames.IntradaySnapshot,
                    APIDisplayNames.IntradayHistory,
                    APIDisplayNames.StreamingIntradayTradesWithHistory,
                    APIDisplayNames.EndOfDayHistory,
                    APIDisplayNames.EndOfDaySnapshot,
                    APIDisplayNames.FreeTextSearch,
                    APIDisplayNames.Estimates,
                    APIDisplayNames.Fundamentals
                ]
            }
        ]
    },
    "2025-05-31": {
        releaseDate: ReleaseDates["2025-05-31"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2025-05-01"],
        changeList: [
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>netChangeLastAuction</code></li>
                    <li><code>percentageChangeLastAuction</code></li>
                    <li><code>totalReturn</code></li>
                    <li><code>netTotalReturn</code></li>
                    <li><code>grossTotalReturn</code></li>
                    <li><code>excessTotalReturn</code></li>
                    <li><code>hedgeTotalReturn</code></li>
                    <li><code>hedgePrice</code></li>
                    <li><code>hedgeNetTotalReturn</code></li>
                    <li><code>hedgeExcessReturn</code></li>
                    <li><code>valuationPrice</code></li>
                    <li><code>indicativeNetAssetValue</code></li>
                    <li><code>yieldToWorst</code></li>
                    <li><code>netAssetValue</code></li>
                    <li><code>fairValue</code></li>
                    <li><code>finalSettlementFuture</code></li>
                    <li><code>finalSettlementOption</code></li>
                    <li><code>percentageChangeValuationPrice</code></li>
                    <li><code>netChangeValuationPrice</code></li>
                    <li><code>percentageChange3Year</code></li>
                    <li><code>percentageChange5Year</code></li>
                    <li><code>trendIndicatorValuation</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.StreamingMarketData, APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>totalReturn</code></li>
                    <li><code>netTotalReturn</code></li>
                    <li><code>grossTotalReturn</code></li>
                    <li><code>excessTotalReturn</code></li>
                    <li><code>hedgeTotalReturn</code></li>
                    <li><code>hedgePrice</code></li>
                    <li><code>hedgeNetTotalReturn</code></li>
                    <li><code>hedgeExcessReturn</code></li>
                    <li><code>valuationPrice</code></li>
                    <li><code>indicativeNetAssetValue</code></li>
                    <li><code>yieldToWorst</code></li>
                    <li><code>netAssetValue</code></li>
                    <li><code>fairValue</code></li>
                    <li><code>finalSettlementFuture</code></li>
                    <li><code>finalSettlementOption</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDaySnapshot]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>totalReturn</code></li>
                    <li><code>netTotalReturn</code></li>
                    <li><code>grossTotalReturn</code></li>
                    <li><code>excessTotalReturn</code></li>
                    <li><code>hedgeTotalReturn</code></li>
                    <li><code>hedgePrice</code></li>
                    <li><code>hedgeNetTotalReturn</code></li>
                    <li><code>hedgeExcessReturn</code></li>
                    <li><code>valuationPrice</code></li>
                    <li><code>indicativeNetAssetValue</code></li>
                    <li><code>yieldToWorst</code></li>
                    <li><code>netAssetValue</code></li>
                    <li><code>fairValue</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDayHistory]
            }
        ]
    },
    "2024-10-31": {
        releaseDate: ReleaseDates["2024-10-31"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2024-10-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>Categorization reference data for instruments</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentClassification]
            },
            {
                "message": `<p class="label">Added API</p>
                <p>Categorization reference data for entities</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EntityClassification]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>bc</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IndexComposition]
            },
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>cryptocurrencySymbol</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentSymbology]
            }
        ]
    },
    "2024-08-30": {
        releaseDate: ReleaseDates["2024-08-30"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2024-08-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>Index composition for instruments</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IndexComposition]
            }
        ]
    },
    "2024-08-21": {
        releaseDate: ReleaseDates["2024-08-21"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2024-08-01"],
        changeList: [
            {
                "message": `<p class="label">Added API</p>
                <p>End-of-day market data prices for instruments</p>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDaySnapshot]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>netChangeLast</code></li>
                    <li><code>netChangeReportedPrice</code></li>
                    <li><code>percentageChangeLast</code></li>
                    <li><code>percentageChangeReportedPrice</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Deprecated field</p>
                <ul>
                    <li><code>percentageChange5Days</code></li>
                <ul>`,
                "type": ChangeTypes.Deprecated,
                "apis": [APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Deprecated field</p>
                <ul>
                    <li><code>last</code></li>
                <ul>`,
                "type": ChangeTypes.Deprecated,
                "apis": [APIDisplayNames.EndOfDayHistory]
            }
        ]
    },
    "2024-06-13": {
        releaseDate: ReleaseDates["2024-06-13"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2024-06-01"],
        changeList: [
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>auctionTheoreticalMatchingPrice</code></li>
                    <li><code>duration</code></li>
                    <li><code>modifiedDuration</code></li>
                    <li><code>convexity</code></li>
                    <li><code>timeToMaturity</code></li>
                    <li><code>yieldToCall</code></li>
                    <li><code>mid</code></li>
                    <li><code>annualisedDividend</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.EndOfDayHistory]
            },
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>percentageChange1Week</code></li>
                    <li><code>percentageChange4Week</code></li>
                    <li><code>percentageChange12Week</code></li>
                    <li><code>percentageChange26Week</code></li>
                    <li><code>percentageChange52Week</code></li>
                    <li><code>latestDividend</code></li>
                    <li><code>annualisedDividend</code></li>
                    <li><code>indicatedAnnualDividend</code></li>
                    <li><code>averageDailyVolume4Week</code></li>
                    <li><code>averageDailyVolume1Week</code></li>
                    <li><code>averageDailyVolume12Week</code></li>
                    <li><code>averageDailyVolume26Week</code></li>
                    <li><code>averageDailyVolume52Week</code></li>
                    <li><code>averageDailyVolumeMonthToDate</code></li>
                    <li><code>averageDailyVolumePreviousMonth</code></li>
                    <li><code>volume1Week</code></li>
                    <li><code>volume4Week</code></li>
                    <li><code>volume12Week</code></li>
                    <li><code>volume26Week</code></li>
                    <li><code>volume52Week</code></li>
                    <li><code>turnover1Week</code></li>
                    <li><code>turnover4Week</code></li>
                    <li><code>turnover12Week</code></li>
                    <li><code>turnover26Week</code></li>
                    <li><code>turnover52Week</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IntradaySnapshot]
            }
        ]
    },
    "2024-03-07": {
        releaseDate: ReleaseDates["2024-03-07"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2024-03-01"],
        changeList: [
            {
                "message": `<p class="label">Added field</p>
                <ul>
                    <li><code>mostliquidmarket.country</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.InstrumentBase]
            },
            {
                "message": `<p class="label">Added enum</p>
                <ul>
                    <li><code>ListingCategory</code> enum: <code>ETFS_EUROCLEAR_BANK_SETTLEMENT</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.ListingBase]
            },
            {
                "message": `<p class="label">Deprecated enum</p>
                <ul>
                    <li><code>ListingCategory</code> enum: <code>ETFS__EUROCLEAR_BANK_SETTLEMENT</code></li>
                <ul>`,
                "type": ChangeTypes.Deprecated,
                "apis": [APIDisplayNames.ListingBase]
            },
        ]
    },
    "2024-01-17": {
        releaseDate: ReleaseDates["2024-01-17"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2024-01-01"],
        changeList: [
            {
                "message": `<p class="label">Added fields</p>
                <ul>
                    <li><code>spreadBestBidAsk</code></li>
                    <li><code>mid</code></li>
                    <li><code>numberOfTrades</code></li>
                    <li><code>auctionTheoreticalMatchingPrice</code></li>
                    <li><code>marketCapitalisation</code></li>
                    <li><code>omega</code></li>
                    <li><code>gearing</code></li>
                    <li><code>highStaticLimit</code></li>
                    <li><code>high1Week</code></li>
                    <li><code>high4Week</code></li>
                    <li><code>high12Week</code></li>
                    <li><code>lowStaticLimit</code></li>
                    <li><code>low1Week</code></li>
                    <li><code>low4Week</code></li>
                    <li><code>low12Week</code></li>
                    <li><code>intrinsicValue</code></li>
                    <li><code>percentageSpreadBestBidAsk</code></li>
                    <li><code>closeYear</code></li>
                <ul>`,
                "type": ChangeTypes.Added,
                "apis": [APIDisplayNames.IntradaySnapshot]
            },
            {
                "message": `<p class="label">Deprecated fields</p>
                <ul>
                    <li><code>listingName</code></li>
                    <li><code>marketName</code></li>
                <ul>`,
                "type": ChangeTypes.Deprecated,
                "apis": [APIDisplayNames.InstrumentBase, APIDisplayNames.EntityBase, APIDisplayNames.ListingBase, APIDisplayNames.MarketBase, APIDisplayNames.InstrumentSymbology, APIDisplayNames.ListingSymbology, APIDisplayNames.IntradaySnapshot, APIDisplayNames.IntradayHistory, APIDisplayNames.EndOfDayHistory]
            },
        ]
    },
    "2023-04-25": {
        releaseDate: ReleaseDates["2023-04-25"],
        majorVersion: APIMajorVersions.v1,
        minorVersion: APIV1MinorVersions["2023-01-01"],
        initialRelease: true,
        changeList: []
    }
}
